/* eslint-disable max-len */
export const LINE_BREAK_BROWSER = '%0D%0A';
export const LINE_BREAK_ANDROID = '%0D%0A%0D%0A';

// If <br> doesn't work on android, try using this LINE_BREAK_ANDROID
export const LINE_BREAK_NATIVE = '<br>';
